import { CompanySearchScreen } from '@/components/CompanySearchScreen';

export default function CompanySearch() {
  return <CompanySearchScreen />;
}
